import { Container, Row, Col } from 'react-bootstrap';
import { useQuery } from '@tanstack/react-query';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { getSummary } from './api/Summary.js';
import { getDam } from './api/Dams.js';
import { getObservationData } from './api/Observations.js';
import RiverSummary from './components/RiverSummary.jsx';
import BottomBarArea from './components/BottomBarArea.jsx';
import DamSummary from './components/DamSummary.jsx';

import hero1 from './assets/images/hero1.jpg';
import styles from './Root.module.css';
import ObservationStats from './components/ObservationStats.jsx';
import CycloneWarning from './components/CycloneWarning.jsx';

const REFETCH_INTERVAL = 900000;
const DAM_KEY = 'ross';
const OBS_STATION_ID = '032040';

function Root() {
  const { t } = useTranslation();
  const { isError, data } = useQuery({
    queryKey: ['summary'],
    queryFn: getSummary,
    refetchInterval: REFETCH_INTERVAL,
  });

  const { isError: isDamError, data: damMeta } = useQuery({
    queryKey: ['ross-dam-meta'],
    queryFn: getDam.bind(this, DAM_KEY),
  });

  const { isError: isObsError, data: obsData } = useQuery({
    queryKey: [`${OBS_STATION_ID}-observations`],
    queryFn: getObservationData.bind(this, OBS_STATION_ID),
  });

  return (
    <>
      <div
        className={clsx(styles.HeroBackground, 'bg-dark', 'text-secondary')}
        style={{ backgroundImage: `url("${hero1}")` }}
      >
        <div className={styles.HeroOverlay}>
          <Container className="py-5">
            <h1 className="display-5 text-white">Live Townsville River Conditions</h1>
            <Col xs={10} md={8} lg={6}>
              <p className="fs-5 mb-4 text-white">
                Townsville&#39;s critical river and flood information all in one place.
              </p>
            </Col>
          </Container>
        </div>
      </div>
      <div className={styles.FrontSummary}>
        <Container>
          <Row>
            <Col xs={12} sm={12} md={4} lg={4}>
              <div className={styles.RiverSummaryCol}>
                <DamSummary dam={getDamSummary(data, DAM_KEY)} damMeta={damMeta} error={isError || isDamError} title={'Ross River Dam'} link={'/rivers/ross#532020'} />
              </div>
            </Col>
            <Col xs={12} sm={12} md={8} lg={8}>
              <div className={styles.ObservationsCol}>
                <ObservationStats observationsData={obsData} error={isObsError} title={t('observations.title')} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className={styles.RiverSummary}>
        <Container>
          <Row>
            <Col xs={12} sm={6} md={3} lg={3} className={styles.RiverSummaryCol}>
              <RiverSummary river={getRiverSummary(data, 'ross')} error={isError} title={'Ross River'} link={'/rivers/ross'} />
            </Col>
            <Col xs={12} sm={6} md={3} lg={3} className={styles.RiverSummaryCol}>
              <RiverSummary river={getRiverSummary(data, 'bohle')} error={isError} title={'Bohle River'} link={'/rivers/bohle'} />
             </Col>
            <Col xs={12} sm={6} md={3} lg={3} className={styles.RiverSummaryCol}>
              <RiverSummary river={getRiverSummary(data, 'black')} error={isError} title={'Black River'} subtitle={'and Bluewater Creek'} link={'/rivers/black'} />
            </Col>
            <Col xs={12} sm={6} md={3} lg={3} className={styles.RiverSummaryCol}>
              <RiverSummary river={getRiverSummary(data, 'alligator')} error={isError} title={'Alligator Creek'} link={'/rivers/alligator'} />
            </Col>
          </Row>
        </Container>
      </div>
      <BottomBarArea>

      </BottomBarArea>
    </>
  );
}

function getRiverSummary(data, riverKey) {
  return data?.rivers?.find((river) => river.key === riverKey);
}

function getDamSummary(data, damKey) {
  return data?.dams?.find((dam) => dam.key === damKey);
}

export default Root;
